export function reduceGridPadding(): void {
    const grid: NodeListOf<Element> | null = document.querySelectorAll('.js-grid');

    grid.forEach(el => {
        const textmediaWithBorder = el.querySelectorAll('.js-textmediaBorder');
        if (textmediaWithBorder.length) {
            el.classList.add('grid--reducePadding');
            el.closest('.grid')?.classList.add('grid--changeWidth');
        }
    });
}
